var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"0-page-bottom-spacing-medium u-padding-bottom-large"},[_c('v-overview-grid',{attrs:{"data-filter-table":"ProductAggregations","data-table":"Products","data-filter":"ProductFilters","data-pagination":"ProductPagination","grid-element":"ProductBlock","filters":_vm.filters}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a6f46b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/customer/shop/Overview.vue
// module id = null
// module chunks = 